module.exports = __webpack_public_path__ + "img/ddwu_gallery2.12f1873d.jpg";